export default "__VITE_ASSET__IhEl7CSa__"